module.exports = __webpack_public_path__ + "media/newstyle/images/services-footer-2-eee1376ed579ea1088c67f12ec34e468.png";